// @flow
import {
  createSlice,
  createEntityAdapter,
  createSelector
} from '@reduxjs/toolkit';

const sliceName = 'launchDarkly';

type Flag = { id: string, value: any };

const darklyAdapter = createEntityAdapter<Flag>();

const launchDarklySlice = createSlice({
  name: sliceName,
  initialState: darklyAdapter.getInitialState(),
  reducers: {
    setData: (state, action) => darklyAdapter.setAll(state, action.payload)
  }
});

export const { setData } = launchDarklySlice.actions;

export const { selectById } = darklyAdapter.getSelectors(
  (state) => state[sliceName]
);

export const selectBrandLogoFlag = (state) =>
  selectById(state, 'srp-brand-logos');

export const selectBrandLogoConfigFlag = (state) =>
  selectById(state, 'brand-logo-config');

export const selectGoogleMapId = (state) =>
  selectById(state, 'google-map-id')?.value || '';

export const selectBrandLogoIsActive = createSelector(
  selectBrandLogoFlag,
  (flag) => flag?.value === true
);

export const selectBrandLogoConfig = createSelector(
  selectBrandLogoConfigFlag,
  (flag) => flag?.value
);

export default launchDarklySlice;
